import { getEncryptObject } from './crypto';

export const moveListItemBack = (arr: any[], index: number) => {
  if (index < 0 || index >= arr.length - 1) {
    console.log('Invalid index.');
    return arr;
  }

  const item = arr.splice(index, 1)[0];
  arr.splice(index + 1, 0, item);

  return arr;
};

export const getNumberToString = (str: string) => {
  const numbersOnly = str.replace(/\D/g, '');
  return numbersOnly;
};

export const moveItemForward = (arr: any[], index: number) => {
  if (index <= 0 || index >= arr.length) {
    console.log('Invalid index.');
    return arr;
  }

  const item = arr.splice(index, 1)[0];
  arr.splice(index - 1, 0, item);

  return arr;
};

export const formatPhoneNumber = (phoneNumber: string) => {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');
  let formatted = cleaned;
  if (cleaned.length === 9) formatted = cleaned.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
  else if (cleaned.length === 10) formatted = cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  else formatted = cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  return formatted;
};

export const checkBetween = (
  startTime: string,
  endTime: string,
  targetStartTime: string,
  targetEndTime: string,
) => {
  const [startHours, startMinutes] = startTime.split(':').map(Number);
  const [endHours, endMinutes] = endTime.split(':').map(Number);
  const [targetStartHours, targetStartMinutes] = targetStartTime.split(':').map(Number);
  const [targetEndHours, targetEndMinutes] = targetEndTime.split(':').map(Number);

  let startDate = new Date();
  startDate.setHours(startHours, startMinutes, 0);
  let endDate = new Date();
  endDate.setHours(endHours, endMinutes, 0);

  let targetStartDate = new Date();
  targetStartDate.setHours(targetStartHours, targetStartMinutes, 0);
  let targetEndDate = new Date();
  targetEndDate.setHours(targetEndHours, targetEndMinutes, 0);

  if (startDate > endDate) {
    if (targetStartDate <= targetEndDate) {
      console.log(
        'start big / target end big',
        targetEndDate <= startDate && targetStartDate >= endDate,
      );
      return targetEndDate <= startDate && targetStartDate >= endDate;
    }
  } else {
    if (targetStartDate > targetEndDate) {
      console.log(
        'end big / target start big',
        targetEndDate <= startDate && targetStartDate >= endDate,
      );
      return targetEndDate <= startDate && targetStartDate >= endDate;
    } else {
      console.log('end big / target end big', startTime, endTime, targetStartTime, targetEndTime);
      return targetEndDate <= startDate || targetStartDate >= endDate;
    }
  }
  return false;
};

export const getTimeValue = (date: string) => {
  const [hour, minute] = date.split(':');
  return Number(hour) * 60 + Number(minute);
};

// 모바일 웹 <=> 웹뷰 판단 후 로직 비교
export const isInAppWebView = () => {
  const ua = navigator.userAgent;

  const isReactNativeWebView = typeof window.ReactNativeWebView !== 'undefined';

  const isAndroidWebView = /wv/.test(ua) || /Android.*Version\/[\d.]+.*Chrome/.test(ua);

  const isIOSWebView = /\b(iPhone|iPod|iPad)\b/.test(ua) && !/Safari/.test(ua) && !/CriOS/.test(ua); // Safari, Chrome 제외

  console.log('ua', ua, isReactNativeWebView, isAndroidWebView, isIOSWebView);

  return isReactNativeWebView || isAndroidWebView || isIOSWebView;
};

export const getActionData = (action: any, params: any) => {
  let requestData: any = {
    type: 'action',
    action,
    params,
  };

  let payEncryptMessage = getEncryptObject(requestData);

  return payEncryptMessage;
};
